import React from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import TableComponent from '../antTable/table';
import CustomPagination from '../antTable/pagenation';
import ViewUser from 'component/modal_components/viewUser';
import EditUserModal from 'component/modal_components/edit';
import DeleteModal from 'component/modal_components/delete_user';
import LockUnlockModal from 'component/modal_components/lock_unlock';
import ChangePasswordModal from 'component/modal_components/password';
import EnableDisableModal from 'component/modal_components/enable_disable';
import { setIsDescending, setPageNumber, setPageSize, setSortType } from 'redux/slices/selectedNodeSlice';
import TableLoader from 'component/loader_component/tableLoader';
import { setSelectedItems, setSelectedItemsValues } from 'redux/slices/userSlice';

export default function UsersData() {
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);
  const { loading, data, totalCount, selectedItems } = useSelector((state) => state.getUsers);
  const { ouAdminRights, portalAdminRights } = useSelector((state) => state.settings);
  const role = localStorage.getItem('role');
  const isSuperAdmin = role === 'superadmin';
  const canView =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserView ?? true : ouAdminRights?.ouAdminuserView ?? true);
  const canEdit =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserEdit ?? true : ouAdminRights?.ouAdminuserEdit ?? true);
  const canDelete =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserDelete ?? true : ouAdminRights?.ouAdminuserDelete ?? true);
  const canResetPassword =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserResetPassword ?? true
      : ouAdminRights?.ouAdminuserResetPassword ?? true);
  const canUnlock =
    isSuperAdmin ||
    (role === 'portaladmin' ? portalAdminRights?.portaluserUnlock ?? true : ouAdminRights?.ouAdminuserUnlock ?? true);
  const canEnableDisable =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserEnableDisable ?? true
      : ouAdminRights?.ouAdminuserEnableDisable ?? true);
  const canBulkUserAction =
    isSuperAdmin ||
    (role === 'portaladmin'
      ? portalAdminRights?.portaluserBulkAction ?? true
      : ouAdminRights?.ouAdminuserBulkAction ?? true);

  const columns = [
    {
      title: 'Display Name',
      dataIndex: 'displayName',
      key: 'name',
      sorter: true,
    },
    {
      title: 'UPN',
      dataIndex: 'userPrincipalName',
      key: 'upn',
      sorter: true,
    },
    {
      title: 'Sam Account Name',
      dataIndex: 'samAccountName',
      key: 'samAccountName',
      sorter: true,
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
    },

    {
      title: 'Actions',
      key: 'action',
      dataIndex: 'isLock',
      render: (_, record) => {
        return (
          <Space>
            {canEdit && !record.isAdmin && <EditUserModal {...record} />}
            {canView && <ViewUser {...record} />}
            {canResetPassword && !record.isAdmin && <ChangePasswordModal {...record} />}
            {canUnlock && <LockUnlockModal {...record} />}
            {canEnableDisable && !record.isAdmin && <EnableDisableModal {...record} />}
            {canDelete && !record.isAdmin && <DeleteModal {...record} />}
          </Space>
        );
      },
    },
  ];

  const handleSorting = (_, __, sorter) => {
    if (sorter.order) {
      const isDescending = sorter.order === 'descend';
      dispatch(setIsDescending(isDescending));
      dispatch(setSortType(sorter.field));
    } else {
      dispatch(setSortType(''));
    }
  };

  // Calculate the data to display on the current page based on currentPage and pageSize
  const startIndex = (selectedNode.pageNumber - 1) * selectedNode.pageSize;
  const endIndex = startIndex + selectedNode.pageSize;

  const handlePagination = async (value, pagination) => {
    dispatch(setPageNumber(value));
    dispatch(setPageSize(pagination));
  };

  const rowSelection = {
    selectedItems,
    onChange: (selectedRowKeys, selectedRows) => {
      dispatch(setSelectedItems(selectedRowKeys));
      dispatch(setSelectedItemsValues(selectedRows));
    },
    selectedRowKeys: selectedItems,
  };

  return (
    <div className='af-user-wrap'>
      <div className='af-user-table-wrap'>
        <TableComponent
          columns={columns}
          data={data}
          onChange={handleSorting}
          rowSelection={canBulkUserAction ? rowSelection : false}
          rowKey='dn'
          loading={{
            spinning: loading,
            indicator: <TableLoader />,
          }}
        />
      </div>
      <div className='af-user-pagination-wrap'>
        <CustomPagination
          loading={loading}
          totalItems={totalCount}
          currentPage={selectedNode.pageNumber}
          pageSize={selectedNode.pageSize}
          onPageChange={handlePagination}
          pageSizeOptions={[20, 50, 100, 200]}
          startIndex={startIndex}
          endIndex={endIndex}
        />
      </div>
    </div>
  );
}
